var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgContactsBook2Line = function SvgContactsBook2Line(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M19.7 21H7.1a2.7 2.7 0 0 1-2.7-2.7V5.7A2.7 2.7 0 0 1 7.1 3h12.6a.9.9 0 0 1 .9.9v16.2a.9.9 0 0 1-.9.9m-.9-1.8v-1.8H7.1a.9.9 0 1 0 0 1.8zM6.2 15.753c.282-.099.585-.153.9-.153h11.7V4.8H7.1a.9.9 0 0 0-.9.9zm6.3-5.553a1.8 1.8 0 1 1 0-3.6 1.8 1.8 0 0 1 0 3.6m-2.7 3.6a2.7 2.7 0 0 1 5.4 0z"
  })));
};
export default SvgContactsBook2Line;